function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
// 定义一个 Stack 类
var Stack = /*#__PURE__*/function () {
  // 构造函数接收一个 maxSize 参数，用于设置栈的最大容量
  function Stack(maxSize) {
    _classCallCheck(this, Stack);
    // 设置栈的最大容量
    this.maxSize = maxSize;
    // 初始化一个空数组来存储栈元素
    this.stack = [];
  }

  // push 方法用于向栈中添加元素
  _createClass(Stack, [{
    key: "push",
    value: function push(item) {
      // 如果栈的当前大小已经达到最大容量
      if (this.stack.length >= this.maxSize) {
        // 移除栈底的元素（数组的第一个元素）
        this.stack.shift();
      }
      // 将新元素添加到栈顶（数组的末尾）
      this.stack.push(item);
    }

    // pop 方法用于从栈中移除并返回栈顶元素
  }, {
    key: "pop",
    value: function pop() {
      return this.stack.pop();
    }

    // display 方法用于返回栈的所有元素
  }, {
    key: "display",
    value: function display() {
      return this.stack;
    }
  }]);
  return Stack;
}();
export { Stack as default };